import { render, staticRenderFns } from "./DropdownList.vue?vue&type=template&id=8adf9bd2&"
import script from "./DropdownList.vue?vue&type=script&lang=js&"
export * from "./DropdownList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports